import React, { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstall(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowInstall(false);
    }
    setDeferredPrompt(null);
  };

  if (!showInstall) return null;

  return (
    <Button onClick={handleInstall} data-testid="install-pwa-btn"
      variant="outline"
      className="flex items-center gap-2 rounded-full border-amber-300 text-amber-700 dark:text-amber-400 dark:border-amber-700 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-sm font-medium px-4 py-2">
      <Download className="h-4 w-4" />
      <span className="hidden sm:inline">{language === 'it' ? 'Salva sul desktop' : 'Save to desktop'}</span>
      <span className="sm:hidden">{language === 'it' ? 'Installa' : 'Install'}</span>
    </Button>
  );
};

export default InstallPWA;
